module.exports = __webpack_public_path__ + "img/Vector11.db12288d.svg";